import PropTypes from 'prop-types'
import {
  StyledWarningInfoContainer,
  StyledInfoBox,
  StyledFlexBox,
  StyledWarningIcon,
  StyledInfo,
  StyledToolTip,
  StyledBannerIconButton,
  StyledBannerCloseIcon
} from '../ChatbotStyles'
import {shouldDisplayInfoText} from '../helpers'

const WarningBanner = ({messages, hiddenWarningBanners, handleBannerCloseFromHook}) => {
  if (!shouldDisplayInfoText(messages, hiddenWarningBanners?.length > 0)) {
    return null
  }

  return (
    <StyledWarningInfoContainer>
      <StyledInfoBox type='warning' tabIndex={0}>
        <StyledFlexBox>
          <StyledWarningIcon />
          <StyledInfo>
            You are reaching your chat storage limit. Once the limit is reached, older messages will be cleared.
          </StyledInfo>
        </StyledFlexBox>
        <StyledToolTip title='Close'>
          <StyledBannerIconButton onClick={handleBannerCloseFromHook} data-testid='warning-banner-close-btn'>
            <StyledBannerCloseIcon />
          </StyledBannerIconButton>
        </StyledToolTip>
      </StyledInfoBox>
    </StyledWarningInfoContainer>
  )
}

WarningBanner.propTypes = {
  messages: PropTypes.array.isRequired,
  hiddenWarningBanners: PropTypes.array,
  handleBannerCloseFromHook: PropTypes.func.isRequired
}

export default WarningBanner

/*
WARNING BANNER COMPONENT

KEY FUNCTIONS:
- shouldDisplayInfoText: Determines when to show banner based on message count and user preferences
- handleBannerCloseFromHook: Dismisses banner and saves user preference

FEATURES:
- Conditional display based on storage threshold
- User preference persistence (won't show again if dismissed)
- Accessible design with tooltips and tabindex
- Warning styling with icon and clear messaging
*/
